import React, { useEffect } from 'react'
import Logout from '../../components/auth/Logout'
import { v1_logout } from '../../actions/v1/auth'
import { removeAllSessionStorage, removeStorage, removeSessionStorage } from '../../utils'
import constant from '../../constant'
const Index = () => {

    useEffect(() => {

        v1_logout().then((res => {
            const preservedLocalStorage = {};
            const preserveKeyPrefixes = [
                `${constant.keys.chatNotificationCursor}.`,
                `${constant.keys.mailboxUnreadSnapshot}.`,
            ];

            Object.keys(localStorage || {}).forEach((key) => {
                if (!key) return;
                const shouldPreserve = preserveKeyPrefixes.some((prefix) => key.startsWith(prefix));
                if (!shouldPreserve) return;

                const value = localStorage.getItem(key);
                if (value !== null) {
                    preservedLocalStorage[key] = value;
                }
            });

            removeStorage('rsc_cache')
            removeSessionStorage(constant.keys.userToken)
            removeAllSessionStorage();
            localStorage.clear();

            Object.entries(preservedLocalStorage).forEach(([key, value]) => {
                localStorage.setItem(key, value);
            });
        }))

    }, [])
    return (

        <React.Fragment>
            <Logout />
        </React.Fragment>
    )
}

export default Index
